/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Switching_To_Local_Pickup_ExplanationInputs */

const en_orders_switching_to_local_pickup_explanation = /** @type {(inputs: Orders_Switching_To_Local_Pickup_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switching to local pickup removes shipping charges and reconciles payment differences.`)
};

const es_orders_switching_to_local_pickup_explanation = /** @type {(inputs: Orders_Switching_To_Local_Pickup_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar a recogida local elimina cargos de envio y reconcilia diferencias de pago.`)
};

/**
* | output |
* | --- |
* | "Switching to local pickup removes shipping charges and reconciles payment differences." |
*
* @param {Orders_Switching_To_Local_Pickup_ExplanationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_switching_to_local_pickup_explanation = /** @type {((inputs?: Orders_Switching_To_Local_Pickup_ExplanationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Switching_To_Local_Pickup_ExplanationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_switching_to_local_pickup_explanation(inputs)
	return es_orders_switching_to_local_pickup_explanation(inputs)
});